module.exports = __webpack_public_path__ + "static/media/icon-vimeo.7d1c4949.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-vimeo.svg
// module id = 399
// module chunks = 0